var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { GenericService } from "../GenericService";
import { HttpClient, HttpParams } from "@angular/common/http";
import { of } from "rxjs";
import { share, map, tap } from "rxjs/operators";
var DocumentTagsService = /** @class */ (function (_super) {
    __extends(DocumentTagsService, _super);
    function DocumentTagsService(http) {
        var _this = _super.call(this) || this;
        _this.http = http;
        _this.cachedDocumentTags = null;
        var queryParams = new HttpParams({
            fromObject: {
                skip: '0',
                limit: '50',
                sortBy: 'name',
                order: 'asc',
            }
        });
        _this.getDocumentTagsRequest = _this.http.get(DocumentTagsService.apiPrefix, { params: queryParams }).pipe(map(function (data) {
            _this.cachedDocumentTags = data.items;
            setTimeout(function () {
                _this.cachedDocumentTags = null; // invalidate tags cache in 20 minutes
            }, 20 * 60 * 1000);
            return data.items;
        }), share() //share results between multiple subscriptions
        );
        return _this;
    }
    DocumentTagsService.prototype.getTags = function () {
        return this.cachedDocumentTags ? of(this.cachedDocumentTags) : this.getDocumentTagsRequest;
    };
    DocumentTagsService.prototype.getPagedTags = function (offset, pageSize, sortBy, order, counts) {
        if (offset === void 0) { offset = 0; }
        if (pageSize === void 0) { pageSize = 20; }
        if (sortBy === void 0) { sortBy = 'name'; }
        if (order === void 0) { order = 'asc'; }
        if (counts === void 0) { counts = true; }
        var queryParams = new HttpParams({
            fromObject: {
                skip: offset.toString(),
                limit: pageSize.toString(),
                sortBy: sortBy,
                order: order,
            }
        });
        return this.http.get(DocumentTagsService.apiPrefix, { params: queryParams });
    };
    DocumentTagsService.prototype.getTagByDocumentId = function (id) {
        return this.http.get(DocumentTagsService.apiPrefix + "/document/" + id);
    };
    DocumentTagsService.prototype.createTag = function (tagData) {
        var _this = this;
        return this.http.post(DocumentTagsService.apiPrefix, tagData).pipe(tap(function () {
            _this.cachedDocumentTags = null;
        }));
    };
    DocumentTagsService.prototype.updateTag = function (tagChanges) {
        var _this = this;
        return this.http.put(DocumentTagsService.apiPrefix, tagChanges).pipe(tap(function () {
            _this.cachedDocumentTags = null;
        }));
    };
    DocumentTagsService.prototype.archiveTag = function (id) {
        var _this = this;
        return this.http.delete(DocumentTagsService.apiPrefix + "/" + id).pipe(tap(function () {
            _this.cachedDocumentTags = null;
        }));
    };
    DocumentTagsService.apiPrefix = '/api/document-tag';
    return DocumentTagsService;
}(GenericService));
export { DocumentTagsService };
